import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const productRoutes: RouteRecordRaw[] = [
  {
    path: '/products',
    name: 'products',
    component: () => import('@/modules/products/views/ProductListView.vue'),
    meta: {
      permission: PERMISSIONS.ESHOP.VIEW,
      projectScoped: true,
    },
  },
]
